import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../../../utils/withDeviceType';
import { IDealFeatureCardModal } from '../../../../types/promoInfo';
import { DealFeaturesModalInfoCard } from '../ModalInfoCard';
import { DealSalePromoModalLayout } from '../../../../components/DealSalePromoModalLayout';

import * as styles from './styles.css';

interface IDealFeaturesModalContentProps extends IDealFeatureCardModal, IWithDeviceTypeProps {
  onContentClick: (e: React.MouseEvent) => void;
  action: React.ReactNode;
}

const DealFeaturesModalContent: React.FC<React.PropsWithChildren<IDealFeaturesModalContentProps>> = ({
  title,
  description,
  details,
  deviceType,
  onContentClick,
  action,
}) => {
  return (
    <DealSalePromoModalLayout className={styles['container']}>
      <ArticleHeading1 as="h2">{title}</ArticleHeading1>
      <div className={cn(styles['description'], styles[deviceType])}>
        <ArticleParagraph1>{description}</ArticleParagraph1>
      </div>
      <div className={styles['details']} onClick={onContentClick}>
        {details.map((d, i) => (
          <DealFeaturesModalInfoCard key={i} title={d.title} image={d.image} badge={d.badge} details={d.details} />
        ))}
      </div>
      <div className={cn(styles['call-to-action-button'], styles[deviceType])}>{action}</div>
    </DealSalePromoModalLayout>
  );
};

const DealFeaturesModalContentWithDeviceType = withDeviceType(DealFeaturesModalContent);
export { DealFeaturesModalContentWithDeviceType as DealFeaturesModalContent };
